export const CONTRACT_STATUSES = {
  draft: 'Draft',
  paid: 'Paid',
  outstanding: 'Outstanding',
  in_negotiation: 'In Negotiation',
  expired: 'Expired',
  terminated: 'Terminated',
  archived: 'Archived'
}
